import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const exciseTaxRateToCity = {
  state: {
    exciseTaxRateToCity: [],
    selectedExciseTaxRateToCity: {},
    selectedExciseTaxRateToCityOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    exciseTaxRateToCity(state) {
      return state.exciseTaxRateToCity
    },
    selectedExciseTaxRateToCity(state) {
      return state.selectedExciseTaxRateToCity
    },
    selectedExciseTaxRateToCityOriginal(state) {
      return state.selectedExciseTaxRateToCityOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    exciseTaxRateToCity(state, payload) {
      state.exciseTaxRateToCity = payload
    },
    selectedExciseTaxRateToCity(state, payload) {
      state.selectedExciseTaxRateToCity = JSON.parse(JSON.stringify(payload))
    },
    selectedExciseTaxRateToCityOriginal(state, payload) {
      state.selectedExciseTaxRateToCityOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedExciseTaxRateToCity(context, payload) {
      context.commit('selectedExciseTaxRateToCity', payload)
    },
    loadExciseTaxRateToCity(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'ExciseTaxRateToCity'
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('exciseTaxRateToCity', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    refreshSelectedExciseTaxRateToCity(context, payload) {
      if (context.state.selectedExciseTaxRateToCity && context.state.selectedExciseTaxRateToCity.ID > 0) {
        context.dispatch('loadSelectedExciseTaxRateToCity', context.state.selectedExciseTaxRateToCity.ID)

      }
    },
    loadSelectedExciseTaxRateToCity(context, payload) {
      if (context.state.selectedExciseTaxRateToCity && context.state.selectedExciseTaxRateToCity.ID != payload) {
        context.commit('selectedExciseTaxRateToCity', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'ExciseTaxRateToCity/' + payload
        context.commit('increaseSearchCount')
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('selectedExciseTaxRateToCity', res.data)
            context.commit('selectedExciseTaxRateToCityOriginal', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    clearLookupCacheAndReloadExciseTaxRateToCity(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadExciseTaxRateToCity')
      }, )
    },
    createExciseTaxRateToCity(context, payload){
      return new Promise((resolve, reject) => {
        const url = `ExciseTaxRateToCity`
        context.commit('saving', true)
        Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise tax rate to city created',},{ root: true })
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadExciseTaxRateToCity')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    patchExciseTaxRateToCity(context, payload){
      return new Promise((resolve, reject) => { 
        var item = context.state.selectedExciseTaxRateToCity
        if (payload.ID && 
        payload.ID == context.state.selectedExciseTaxRateToCityOriginal.ID)  {
        item = payload
        }
        var patchPayload = {}
        if (!payload.patchDoc || !payload.ID) {
          let original = context.state.selectedExciseTaxRateToCityOriginal
          let current = item
          patchPayload.ID = item.ID
          var diff = jsonpatch.compare(
                original,
                current
              )
          patchPayload.patchDoc = diff

        } else {
          patchPayload = payload
        }
        if (patchPayload.patchDoc.length > 0) {
          const url = `ExciseTaxRateToCity/${ patchPayload.ID }`
          context.commit('saving', true)
          Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          .then(
            (res) => {
              context.dispatch('messages/toastMessage',
              {color: 'success', message: 'excise tax rate to city updated',},{ root: true })
              //if you will always need to reload the list after an update
              //you can uncomment out the following dispatch line.
              //Alternatively you can reload whatever object you need
              //when the promise resolves in the component that called it.
              //context.dispatch('loadExciseTaxRateToCity')
              context.commit('saving', false)
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.commit('saving', false)
              context.dispatch('errors/handleError', err, { root: true })
              reject(err)
            },
          )
        } else {
          resolve('no changes')
        }
      })
    },
    updateExciseTaxRateToCity(context, payload){
      return new Promise((resolve, reject) => { 
        const url = `ExciseTaxRateToCity/${ payload.ID }`
        context.commit('saving', true)
        Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise tax rate to city updated',},{ root: true })
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadExciseTaxRateToCity')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    saveExciseTaxRateToCity(context, payload){
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateExciseTaxRateToCity', payload)
          .then((res) => resolve(res), (err) => reject(err))
        } else {
          context.dispatch('createExciseTaxRateToCity', payload)
          .then((res) => resolve(res), (err) => reject(err))
        }
      })
    },
    deleteExciseTaxRateToCity(context, payload){
      return new Promise((resolve, reject) => {
        const url = `ExciseTaxRateToCity/${ payload.ID }`
        Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise tax rate to city deleted',},{ root: true })
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadExciseTaxRateToCity')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
  },
}

export default exciseTaxRateToCity